import BoardsListControllerLoader from './BoardsListControllerLoader'
export default BoardsListControllerLoader
